import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CurrencyInput from "../../../components/CurrencyInput";
import { getCurrency } from "../../../utils/ApiCalls/Currecny";

const EditCurreny = () => {
  const params = useParams();
  const [cardtype, setCardType] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Currency",
      route: "/website/loyalty/currency",
    },
    {
      title: "Edit Currency",
      route: "/website/loyalty/currency/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getCurrency({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setCardType(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Currency"}>
       <CustomHeaderTitle title={"Edit Currency"}/>
      <HeaderBread
        navigation={navigation}
        title={"Edit Currency"}
      ></HeaderBread>
      {cardtype && <CurrencyInput currency={cardtype} />}
    </Layout>
  );
};

export default EditCurreny;
